import {StoredProcConfiguration} from './StoredProcConfiguration';

export class StoredFuncConfiguration extends StoredProcConfiguration {
exitStatusOnExpectedResult: boolean | null;
exitStatusOnUnexpectedResult: boolean | null;
expectedResult: string;
expectedResultType: string;
unexpectedResultMessage: string;
}

